<template>
<div>
  <el-form style="margin-right: 50px" :model="setForm" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="睡眠时间" label-width="120px">
      <div style="display: flex">
        <div style="flex: 1">
          <el-time-picker v-fixZoom v-model="setForm.start" default-time="20:00:00"
                          placeholder="开始时间" format="HH:mm" value-format="HH:mm:ss" style="width: 100%">
          </el-time-picker>
        </div>
        <div style="margin: 0 5px">至</div>
        <div style="flex: 1">
          <el-time-picker v-fixZoom v-model="setForm.end" default-time="08:00:00"
                          placeholder="开始时间" format="HH:mm" value-format="HH:mm:ss" style="width: 100%">
          </el-time-picker>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="离床时长" label-width="120px">
      <el-input placeholder="请输入" type="number" v-model="setForm.time">
        <template slot="append">分钟</template>
      </el-input>
      <span style="color: rgb(252, 66, 66);font-size: 12px">0代表为不设置离床报警</span>
    </el-form-item>
  </el-form>
  <div style="height: 60px;margin: 30px 30px 0">
    <el-row>
      <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
      <el-col :span="12"><div class="send-btn" @click="submitSet()"><span>确定</span></div></el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {querycommand, sendcommand} from '../../../api/device'
export default {
  name: 'setSleep',
  model: {
    prop: 'subShow1',
    event: 'change'
  },
  props: {
    sleepObj: {
      type: Object
    }
  },
  data () {
    return {
      commandArr: '',
      setForm: {
        start: '',
        end: '',
        time: ''
      }
    }
  },
  created () {
    this.getDeviceCommand()
  },
  methods: {
    getDeviceCommand () {
      let data = {
        imei: this.sleepObj.device.deviceid,
        did: this.sleepObj.device.id
      }
      querycommand(data).then(res => {
        let resDatas = res.data
        if (resDatas !== null) {
          for (let i = 0; i < resDatas.length; i++) {
            let resData = resDatas[i]
            let key = resData.key
            let value = resData.value
            if (key === 'sleepalarm') {
              this.commandArr = value.split('|')
              if (this.sleepObj.isMain) {
                let val4 = this.commandArr[3] !== '' ? (this.commandArr[3].slice(0, 2) + ':' + this.commandArr[3].slice(2, 4) + ':' + this.commandArr[3].slice(4, 6)) : ''
                let val5 = this.commandArr[4] !== '' ? (this.commandArr[4].slice(0, 2) + ':' + this.commandArr[4].slice(2, 4) + ':' + this.commandArr[4].slice(4, 6)) : ''
                if (val4 !== '' && val5 !== '') {
                  this.setForm.start = val4
                  this.setForm.end = val5
                }
                if (this.commandArr[5] !== '') {
                  this.setForm.time = parseInt(this.commandArr[5]) / 60
                }
              } else {
                if (parseInt(this.commandArr[2]) === this.sleepObj.subItem.id) {
                  let val4 = this.commandArr[3] !== '' ? (this.commandArr[3].slice(0, 2) + ':' + this.commandArr[3].slice(2, 4) + ':' + this.commandArr[3].slice(4, 6)) : ''
                  let val5 = this.commandArr[4] !== '' ? (this.commandArr[4].slice(0, 2) + ':' + this.commandArr[4].slice(2, 4) + ':' + this.commandArr[4].slice(4, 6)) : ''
                  if (val4 !== '' && val5 !== '') {
                    this.setForm.start = val4
                    this.setForm.end = val5
                  }
                  if (this.commandArr[5] !== '') {
                    this.setForm.time = parseInt(this.commandArr[5]) / 60
                  }
                }
              }
            }
          }
        }
      })
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submitSet () {
      let data = {
        imei: this.sleepObj.device.deviceid,
        did: this.sleepObj.device.id,
        subdid: this.sleepObj.isMain ? 0 : this.sleepObj.subItem.id,
        method: 'sleepalarm',
        command1: ''
      }
      let val1 = 1 // 是否开启离床报警
      let val2 = this.sleepObj.isMain ? 0 : 1 // 是否子机
      let val3 = this.sleepObj.isMain ? 0 : this.sleepObj.subItem.id
      let val4 = ''
      let val5 = ''
      let val6 = this.setForm.time * 60
      if (this.setForm.time === 0 || this.setForm.time === '') {
        val1 = 0
      }
      if (this.setForm.start !== '' && this.setForm.end !== '') {
        let start = this.setForm.start.split(':')
        start.forEach(item => {
          val4 = val4 + item
        })
        let end = this.setForm.end.split(':')
        end.forEach(item => {
          val5 = val5 + item
        })
      } else {
        this.$message({type: 'warning', message: '请选择时间范围'})
        return
      }
      data.command1 = val1 + '|' + val2 + '|' + val3 + '|' + val4 + '|' + val5 + '|' + val6
      console.log(data)
      sendcommand(data).then(res => {
        this.$notify({title: '成功', message: '成功设置', type: 'success'})
        this.$emit('change', false)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/setSleep.vue